import gql from 'graphql-tag';
import { type DocumentNode } from 'graphql';
import { type GraphQLTaggedNode } from 'relay-runtime';

export function toDocumentNode(graphqlTaggedNode: GraphQLTaggedNode | DocumentNode): DocumentNode {
	if (typeof graphqlTaggedNode === 'string') {
		// For backwards-compatibility only; that's why `string` is not specified as an accepted argument type
		return gql(graphqlTaggedNode);
	}
	if ('kind' in graphqlTaggedNode && 'definitions' in graphqlTaggedNode) {
		return graphqlTaggedNode;
	}

	if (!('params' in graphqlTaggedNode)) {
		throw new Error(
			'[Relay Migration] unsupported tagged node provided. Please make sure you generated Relay artifacts for your operation',
		);
	}

	const operationText = graphqlTaggedNode.params.text;

	if (!operationText) {
		throw new Error(
			'[Relay Migration] The provided `ConcreteRequest` did not specify `params.text` properties that is required for Apollo deprecation. Make sure you keep the `persiste: { includeQueryText: true }` Relay compiler configuration option ',
		);
	}

	return gql(graphqlTaggedNode.params.text);
}
